<template>
  <div id="wdbm" class="container">
    <div class="content">
      <div class="box">
        <div class="title">
          <span>{{learnEmployee.JobName}}</span>
        </div>
        <el-table class="table-xueyuan" :data="[learnEmployee]">
          <el-table-column label="" width="100">
            <template slot-scope="scope">
              <div class="pic">
                <img :src="scope.row.Pic" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="姓名/性别/身份证号">
            <template slot-scope="scope">
              <div class="item">
                <div>
                  <span style="color: #333333;font-weight: 600;">{{scope.row.Name}}</span>
                  <span>{{scope.row.Sex==0?'男':'女'}}</span>
                </div>
                <div>
                  <span>{{scope.row.IdNumber}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Mobile" align="right" label="完成课时">
            <template slot-scope="scope">
              <div class="item">
                <div>
                  <k-progress :data="{wc:0,hg:scope.row.CompleteLessonCount,zs:scope.row.LessonCount}"></k-progress>
                </div>
                <div class='tj-number'>
                  <span>
                    <span style="color: #16cfd0;">{{scope.row.CompleteLessonCount}}</span>/
                    <span style="color: #777777;">{{scope.row.LessonCount}}</span>
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="" align="center" width="40">
            <template slot-scope="scope">
              <div class="item">
                <div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="开始学习时间" width="170">
            <template slot-scope="scope">
              <div class="item">
                <div>
                  {{scope.row.FirstUpdateProcessTime | dateformat('YYYY-MM-DD HH:mm')}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="最后学习时间" width="170">
            <template slot-scope="scope">
              <div class="item">
                <div>
                  {{scope.row.LastUpdateProcessTime | dateformat('YYYY-MM-DD HH:mm')}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="最后学习IP" width="150">
            <template slot-scope="scope">
              <div class="item">
                <div>
                  {{scope.row.LastUpdateProcessIP}}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-table class="table-lesson" :data="[learnEmployeeLesson]">
      <el-table-column prop="Name" label="课程名称">
      </el-table-column>
      <el-table-column prop="Teachers" label="讲师" width="150">
      </el-table-column>
      <el-table-column align="right" label="学习进度（秒）" width="150">
        <template slot-scope="scope">
          <div>
            <span style="color: #16cfd0;">{{scope.row.Progress}}</span>/
            <span>{{scope.row.Duration}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="40">
      </el-table-column>
      <el-table-column label="开始学习时间" width="160">
        <template slot-scope="scope">
          <div class="item">
            <div>
              {{scope.row.FirstUpdateProcessTime | dateformat('YYYY-MM-DD HH:mm')}}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="最后学习时间" width="160">
        <template slot-scope="scope">
          <div class="item">
            <div>
              {{scope.row.UpdateProcessTime | dateformat('YYYY-MM-DD HH:mm')}}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="最后学习IP" width="160">
        <template slot-scope="scope">
          <div class="item">
            <div>
              {{scope.row.UpdateProcessIP}}
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="table-lesson" :data="learnEmployeeLessonLog">
      <el-table-column prop="PlatformName" label="学习平台" width="160">
      </el-table-column>
      <el-table-column align="right" label="学习进度（秒）">
        <template slot-scope="scope">
          <div>
            <span style="color: #16cfd0;">{{scope.row.Progress}}</span>/
            <span>{{learnEmployeeLesson.Duration}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="160">
      </el-table-column>
      <el-table-column prop="IP" label="IP">
      </el-table-column>
      <el-table-column label="学习时间">
        <template slot-scope="scope">
          <div class="item">
            <div>
              {{scope.row.CreatedTime | dateformat('YYYY-MM-DD HH:mm')}}
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="fooler">
      <div class="fooler-btn">
        <el-button class="k-btn-default lg" @click="onCancel">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, ProjectSettings } from '@/views/base/base.js'
export default {
  name: 'yyglxxglxxjl',
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      learnEmployee: 'getLearningmgtEmployee',
      learnEmployeeLesson: 'getLearningmgtEmployeeLesson',
      learnEmployeeLessonLog: 'getLearningmgtEmployeeLessonLog'
    })
  },
  filters: {
    dateformat(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
      if (dataStr === null) {
        return '';
      }
      return moment(dataStr).format(pattern)
    }
  },
  mounted() {
    // let that = this;
    let learnId = this.$route.query.LearnId;
    let jobId = this.$route.query.JobId;
    let employeeId = this.$route.query.EmployeeId;
    let lessonId = this.$route.query.LessonId;
    this.$store.dispatch('getLearningmgtEmployee', { learnId: learnId, jobId: jobId, employeeId: employeeId }).then(res => {
      document.title = res.Data.Name + ' - 课时学习记录 - ' + ProjectSettings.Title;
    });
    this.$store.dispatch('getLearningmgtEmployeeLesson', { learnId: learnId, jobId: jobId, employeeId: employeeId, lessonId: lessonId });
    this.$store.dispatch('getLearningmgtEmployeeLessonLog', { learnId: learnId, jobId: jobId, employeeId: employeeId, lessonId: lessonId });
  },

  methods: {
    onCancel() {
      this.$router.push({ name: 'studyrecord', query: { JobId: this.learnEmployee.JobId, Name: this.learnEmployee.Name, IdNumber: this.learnEmployee.IdNumber } });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/list.scss';
.container {
  display: flex;
  flex-direction: column;
  .header {
    margin-top: 25px;
    .item {
      overflow: hidden;
      display: flex;
      flex-direction: row;
      background-color: #f9f9f9;
      border-radius: 4px;
      position: relative;
      .item-left {
        height: 230px;
        width: 280px;
        min-width: 280px;
        img {
          max-width: 100%;
          height: 100%;
        }
      }
      .item-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-left: 28px;
        margin-right: 20px;
        .item-content {
          display: flex;
          flex-direction: column;
          color: #777;
          .title {
            font-size: 24px;
            color: #2f2f2f;
            margin-top: 32px;
            margin-bottom: 16px;
            font-weight: 700;
          }
          .no {
            color: #777;
            font-size: 16px;
            margin-top: 18px;
            margin-left: 20px;
            font-weight: 400;
          }
          span {
            font-size: 16px;
            margin-bottom: 5px;
          }
          .row-progress-bar {
            width: 65%;
            .progress-contert {
              display: flex;
              justify-content: space-between;
              margin-top: 12px;
              padding-right: 10px;
            }
            .span-href:hover {
              color: #16cfd0;
              cursor: pointer;
            }
          }
          .address {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-top: 3px;
            margin-bottom: 10px;
            width: 95%;
          }
        }
        .item-fooler {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 95%;
          .price {
            font-size: 30px;
            color: #16cfd0;
          }
          span {
            font-size: 16px;
          }
        }
      }
      .item-status-label {
        position: absolute;
        right: -60px;
        top: -60px;
        width: 120px;
        height: 120px;
        background-color: #ff6715;
        text-align: center;
        transform: rotate(45deg);
        box-shadow: 0 1px 1px #ccc;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        i {
          color: #fff;
        }
        span {
          margin-bottom: 8px;
          color: #fff;
        }
        &.tg {
          background-color: #16cfd0;
        }
        &.jj {
          background-color: #a8a8a8;
        }
        &.shz {
          background-color: #ff6715;
        }
      }
    }
  }
  .content {
    .box {
      display: flex;
      flex-direction: column;
      .title {
        margin-top: 70px;
        span {
          font-size: 30px;
          float: left;
          color: #333;
        }
      }
      .main {
        width: 100%;
        margin-top: 60px;
      }
      .table-xueyuan {
        margin-top: 35px;
      }
    }
    .box-process {
      display: flex;
      flex-direction: column;
      > .title {
        margin-top: 70px;
        span {
          font-size: 30px;
          float: left;
          color: #333;
        }
      }
      .main {
        width: 100%;
        margin-top: 30px;
        border: 1px solid #eaeaea;
        > .row {
          line-height: 40px;
          padding: 30px 40px;
          margin: 0px;
          & + .row {
            border-top: 1px solid #eaeaea !important;
          }
          .span-no {
            font-size: 70px;
            margin: 20px 0px 0px 0px;
          }
          .content-sh {
            display: flex;
            flex-direction: column;
            font-size: 16px;
            color: #777777;
            width: 600px;
            .title {
              font-size: 24px;
              color: #333333;
              line-height: 46px;
              display: flex;
              align-items: center;
              .tag {
                padding: 0 4px;
                background-color: #ff6715;
                border-radius: 4px;
                color: #fff;
                font-size: 12px;
                height: 20px;
                line-height: 20px;
                display: inline-block;
                margin-left: 10px;
              }
            }
            .row {
              display: flex;
              align-items: center;
              width: 600px;
              justify-content: space-between;
            }
          }
        }
      }
    }
    .tj-number {
      text-align: right;
      span {
        margin: 0px !important;
      }
    }
    .cell-btn {
      display: flex;
      align-items: center;
      color: #16cfd0;
      cursor: pointer;
    }
  }
  .table-lesson {
    margin-top: 60px;
    .cell-btn {
      display: flex;
      align-items: center;
      color: #16cfd0;
      cursor: pointer;
    }
  }
  .fooler {
    margin-top: 60px;
    .fooler-btn {
      display: flex;
      button + button {
        margin-left: 30px;
      }
    }
  }
}
</style>
<style>
#wdbm .el-table__header thead th > div {
  color: #333;
  font-weight: 600;
}
#wdbm .el-table th,
#wdbm .el-table td {
  padding: 18px 0;
}
#wdbm .el-table th.is-leaf {
  border-top: 0;
  border-bottom: 1px solid #ebeef5;
}
</style>
<style scoped>
.el-table >>> .el-table__row:hover,
.el-table >>> .el-table__row:focus {
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.16);
}
.el-table >>> .el-table__row {
  transition: 0.3s all ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/views/home/study_lesson_log.vue